import { useNavigate } from 'react-router'
import { ChipRail } from '@carouselgg/nexus/chip-rail'
import { ButtonLink } from '@carouselgg/nexus/button'
import { TrustGauge } from '@carouselgg/nexus/trust-gauge'
import { Plus } from '@carouselgg/nexus/icon'
import type { GameTrustScore, TrustScore } from '@carouselgg/auth/types'
import styles from './ScopeRail.module.css'

export const OVERALL_KEY = '__overall'

/**
 * Which score the page is showing: the Carousel score pinned first, then one
 * chip per game, then a way to add another game.
 */
export function ScopeRail({ overall, games, selected }: {
  overall: TrustScore
  games: GameTrustScore[]
  /** A game slug, or OVERALL_KEY. */
  selected: string
}) {
  const navigate = useNavigate()

  return (
    <ChipRail
      aria-label="Which trust score"
      selected={selected}
      onSelect={(key) => navigate(key === OVERALL_KEY ? '/trust' : `/trust/${key}`)}
      pinned={[{
        key: OVERALL_KEY,
        eyebrow: 'Carousel score',
        label: overall.level,
        leading: <TrustGauge score={overall.score} size={32} title={`Carousel score: ${overall.score}`} />,
      }]}
      items={games.map((g) => ({
        key: g.game_slug,
        eyebrow: g.game_name,
        label: g.score.level,
        leading: (
          <TrustGauge
            score={g.score.score}
            size={32}
            title={`${g.game_name} score: ${g.score.score}`}
          />
        ),
      }))}
      trailing={
        <ButtonLink to="/settings/connections" variant="secondary" size="sm" className={styles.add}>
          <Plus size={14} aria-hidden="true" /> Add a game
        </ButtonLink>
      }
    />
  )
}
